const store = new Map<string, string>();

export function getMemoryDraft(key: string): string | null {
  return store.get(key) ?? null;
}

export function setMemoryDraft(key: string, value: string): void {
  store.set(key, value);
}

export function removeMemoryDraft(key: string): void {
  store.delete(key);
}

export function clearMemoryDrafts(): void {
  store.clear();
}
